var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderIcoUserColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.553 11.0618C15.9654 12.6921 17.7991 15.2958 17.9993 19.0009C17.6679 19.0009 17.3733 19.0009 17.0779 19.0009C16.7893 19.0009 16.5007 19.0009 16.1888 19.0009C16.1116 16.7363 15.1985 14.8794 13.3311 13.4982C11.9923 12.5088 10.4585 12.0548 8.77773 12.101C5.07517 12.2021 1.88464 15.0548 1.80517 18.9807C1.22269 18.9807 0.640207 18.9807 0 18.9807C0.191912 15.2958 2.03232 12.6863 5.46275 11.0575C3.69206 9.79243 2.71376 8.12683 2.72125 5.99647C2.72725 4.34747 3.36221 2.92073 4.5789 1.75885C7.04602 -0.596664 10.9817 -0.574292 13.4361 1.7639C15.9842 4.19014 16.0614 8.72869 12.553 11.0618ZM9.00562 10.3582C11.4855 10.3575 13.4766 8.44508 13.4841 6.05781C13.4916 3.66188 11.4907 1.72565 9.00637 1.72421C6.51976 1.72205 4.51068 3.6525 4.50918 6.04338C4.50768 8.43642 6.51152 10.3589 9.00562 10.3582Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 15.9312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8CBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcoUserColor);
export default __webpack_public_path__ + "static/media/header-ico-user-color.51617694c00d7465975d8069e8decc70.svg";
export { ForwardRef as ReactComponent };